import React from "react";
import { motion } from "framer-motion";
import { FlameIcon, GlobeIcon } from "lucide-react";
type ScarcityBarProps = {
  tone?: "light" | "dark";
};
export function ScarcityBar({
  tone = "light"
}: ScarcityBarProps) {
  const dark = tone === "dark";
  return <div className="mx-auto w-full max-w-md" data-id="element-52" data-mp="2l33ha6gt9suc">
      <div className={`rounded-2xl p-4 ${dark ? "bg-navy-800 ring-1 ring-white/10" : "bg-white ring-1 ring-cream-200"}`} data-id="element-53" data-mp="2q2zadanyzzv4">
        <div className="flex items-center justify-between gap-3" data-id="element-54" data-mp="2b56yqtljnvm7">
          <p className={`flex items-center gap-1.5 text-sm font-bold ${dark ? "text-white" : "text-ink"}`} data-id="element-55" data-mp="2g63blwnvis3r">
            <FlameIcon className="h-4 w-4 text-red-500" aria-hidden="true" data-id="element-56" data-mp="2273oitg0el9p" />
            Only 7 accesses left at the launch price!
          </p>
          <span className="shrink-0 text-sm font-extrabold text-red-500" data-id="element-57" data-mp="2779abszlldjv">93%</span>
        </div>
        <div className={`mt-3 h-4 w-full overflow-hidden rounded-full ${dark ? "bg-navy-950" : "bg-cream-200"}`} role="progressbar" aria-valuenow={93} aria-valuemin={0} aria-valuemax={100} aria-label="Launch price spots claimed" data-id="element-58" data-mp="cm6uimig9bd">
          <motion.div className="h-full rounded-full bg-red-500" initial={{
          width: "60%"
        }} whileInView={{
          width: "93%"
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-59" data-mp="2zj6z0024wdjy" />
        </div>
        <p className={`mt-2 text-xs font-semibold uppercase tracking-wide ${dark ? "text-navy-100/70" : "text-muted"}`} data-id="element-60" data-mp="2koah0v4iwbto">
          93% claimed · price goes up when spots run out
        </p>
      </div>
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-center text-sm ${dark ? "text-navy-100/80" : "text-muted"}`} data-id="element-61" data-mp="2uk3t6deby3ax">
        <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-62" data-mp="9vpjo4mpzxbg" />
        Your currency is converted automatically based on your location.
      </p>
    </div>;
}